/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Image from "next/image";

import { RichText, Link as JssLink, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";

import { CleanRelativeLink } from "components/Shared/DomainSplit";

import { ComponentProps } from "lib/component-props";

type CulturalYearsItemProps = ComponentProps & {
  fields: any;
  locale: any;
};

const CulturalYearsItem = (props: CulturalYearsItemProps): JSX.Element => {
  return (
    <>
      {/* here comes the page heading with breadcrumbs */}
      {props?.fields?.title?.value && (
        <div className="bg-primary-25 py-10 flex flex-col items-start gap-4">
          <h1 className="responsive text-3xl md:text-4xl text-primary-1000 font-semibold">
            {props?.fields?.title?.value}
          </h1>

          {props?.fields?.description?.value && (
            <div className="responsive">
              <RichText
                field={props?.fields?.description}
                className={"text-primary-1000 text-base font-normal animate-top-dga"}
              />
            </div>
          )}
        </div>
      )}

      {/* here comes the main section, description and cards */}
      <div className="responsive py-8 md:py-10 space-y-4 md:space-y-0 overflow-hidden">
        {/* here come the cards */}
        {props?.fields?.childItems?.length > 0 &&
          props?.fields?.childItems?.map((Culture: any, index: number) => {
            return (
              <div
                key={index}
                className="animate-top-dga flex flex-col md:flex-row items-stretch gap-6 md:gap-8 lg:gap-10 xl:gap-14 w-full px-4 py-4 md:py-10 rounded-2xl border border-neutral-300 md:border-transparent"
              >
                {/* here is the image/video section */}
                {(Culture?.fields?.LogoImage?.value?.src ||
                  Culture?.fields?.Videolink?.value?.href ||
                  Culture?.fields?.Image?.value?.src) && (
                    <div className="relative flex justify-center items-center w-full flex-1 min-h-[250px] rounded-lg overflow-hidden">
                      <div
                        className={`opacity-60 z-10 duration-500 ease-in absolute bottom-0 h-full w-full bg-[#0F2837]`}
                      />
                      {Culture?.fields?.LogoImage?.value?.src && (
                        <div className="relative w-[170px] h-[170px] md:w-[150px] md:h-[150px] h-lg:lg:w-[200px] h-lg:lg:h-[200px]">
                          <Image
                            className="z-20"
                            src={Culture?.fields?.LogoImage?.value?.src}
                            width={Culture?.fields?.LogoImage?.value?.width}
                            height={Culture?.fields?.LogoImage?.value?.height}
                            alt={(Culture?.fields?.LogoImage?.value?.alt ?? "").trim() || (Culture?.fields?.Title?.value ?? "").trim() || "Cultural year logo"}
                            layout="fill"
                            objectFit="contain"
                          />
                        </div>
                      )}
                      {Culture?.fields?.Videolink?.value?.href ? (
                        <video
                          src={Culture?.fields?.Videolink?.value?.href}
                          poster={Culture?.fields?.Image?.value?.src}
                          autoPlay
                          loop
                          className=" w-full h-full absolute object-cover"
                          muted
                          controls={false}
                          webkit-playsinline
                          playsInline
                          aria-label={Culture?.fields?.Title?.value || "Cultural year video"}
                        >
                          <track kind="captions" />
                        </video>
                      ) : (
                        Culture?.fields?.Image?.value?.src && (
                          <div className=" absolute  h-full w-full top-0  ">
                            <Image
                              className="z-0"
                              layout="fill"
                              objectFit="cover"
                              objectPosition="center"
                              src={Culture?.fields?.Image?.value?.src}
                              width={Culture?.fields?.Image?.value?.width}
                              height={Culture?.fields?.Image?.value?.height}
                              alt={(Culture?.fields?.Image?.value?.alt ?? "").trim() || (Culture?.fields?.Title?.value ?? "").trim() || "Cultural year image"}
                            />
                          </div>
                        )
                      )}
                    </div>
                  )}

                {/* here is the title and description section */}
                <div className="flex-1 flex flex-col gap-6">
                  {(Culture?.fields?.Title?.value || Culture?.fields?.Description?.value) && (
                    <div>
                      {Culture?.fields?.Title?.value && (
                        <h2 className="text-lg text-neutral-800 font-bold">
                          {Culture?.fields?.Title?.value}
                        </h2>
                      )}

                      {Culture?.fields?.Description?.value && (
                        <RichText
                          field={Culture?.fields?.Description}
                          className="text-base text-neutral-800 font-normal"
                        />
                      )}
                    </div>
                  )}

                  {Culture?.fields?.CTAURL?.value.linktype == "external" &&
                    Culture?.fields?.CTAURL?.value && (
                      <JssLink key={index} field={Culture?.fields?.CTAURL?.value} className="w-fit">
                        <button className="dga-primary-button w-fit">
                          {Culture?.fields?.CTAText?.value}
                        </button>
                      </JssLink>
                    )}

                  {Culture?.fields?.CTAURL?.value.linktype == "internal" &&
                    Culture?.fields?.CTAURL?.value.href && (
                      <a
                        key={index}
                        href={CleanRelativeLink(Culture?.fields?.CTAURL?.value.href)}
                        target={Culture?.fields?.CTAURL?.value.target || "_self"}
                        className="dga-primary-button w-fit"
                      >
                        {Culture?.fields?.CTAText?.value}
                      </a>
                    )}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};
export default withDatasourceCheck()<CulturalYearsItemProps>(CulturalYearsItem);
